import React, { useEffect, useState, useCallback } from "react";
import { Spinner, Col, Container, Row } from "react-bootstrap";
import TableData from "./component/tableData";
import { useSelector } from "react-redux";
import { get, updateToken } from "../../../helpers/api_helper";
import Pagination from "../../../components/Pagination";

const TimeZone = () => {
  const token = useSelector((state) => state.login.token);
  const [timezone, setTimezone] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(10);
  const [totalPages, setTotalPages] = useState(0);
  const [loading, setLoading] = useState(true);

  const fetchTimezone = useCallback(
    async (page = 1) => {
      try {
        setLoading(true);
        const response = await get(
          `user/admin/timezone/list?skip=${page}&limit=${itemsPerPage}`
        );
        if (response?.success) {
          setTimezone(response?.data?.items || []);
          setTotalPages(response?.data?.totalPages || 1);
        } else {
          console.log("Failed to fetch timezone");
          setTimezone([]);
        }
      } catch (error) {
        console.log(error);
        setTimezone([]);
      } finally {
        setLoading(false);
      }
    },
    [itemsPerPage]
  );

  useEffect(() => {
    if (token) {
      updateToken(token);
      fetchTimezone(currentPage);
    }
  }, [token, fetchTimezone, currentPage]);

  const handlePageChange = (newPage) => {
    if (newPage > 0 && newPage <= totalPages) {
      setCurrentPage(newPage);
    }
  };

  return (
    <>
      <section className="TimeZone position-relative py-2">
        <Container>
          <Row>
            <Col lg="12" className="my-2">
              <div className="d-flex align-items-start sectionHeader justify-content-between gap-10 flex-wrap filterBtns">
                <div className="left">
                  <h5 className="m-0 fw-sbold">Timezone Details</h5>
                  <p className="m-0 text-muted py-1">
                    It is a long established fact that a reader will be
                    distracted by the readable
                  </p>
                </div>
              </div>
            </Col>
            <Col lg="12" className="my-2">
              <div className="commonTable scrollable-table-container">
                {loading ? (
                  <div
                    className="d-flex justify-content-center align-items-center"
                    style={{ height: "100px" }}
                  >
                    <Spinner animation="border" role="status">
                      <span className="visually-hidden">Loading...</span>
                    </Spinner>
                  </div>
                ) : timezone.length > 0 ? (
                  <>
                    <TableData timezone={timezone} setRefresh={fetchTimezone} />
                    
                    {totalPages > 1 && (
                      <Pagination
                        currentPage={currentPage}
                        totalPages={totalPages}
                        onPageChange={handlePageChange}
                      />
                    )}
                  </>
                ) : (
                  <p>No Timezone data available.</p>
                )}
              </div>
            </Col>
          </Row>
        </Container>
      </section>
    </>
  );
};

export default TimeZone;
